{% verbatim %}
<button id="likeScore" appName="{{app_name}}" object="{{object_name}}" objectid="{{object_id}}" direction="{{direction}}" handlerName="{{handler_name}}" class="like icon-heart youLike {{class}} {{#show_percent}}like-percent{{/show_percent}}">&nbsp;{{score}}</button>
{% endverbatim %}
